import { getToolCatalog } from '../api/mcpPermissionsApi';
import { useResourcesStore } from 'vince-core/stores/resourcesStore';
import { ResourceType } from 'vince-core/types/common';
import { getActions } from 'vince-core/constants/common';
import type { ResourceItem } from 'vince-core/types/common';

export default defineNuxtPlugin(() => {
    const store = useResourcesStore();

    store.registerResource(ResourceType.MCP_TOOL_PERMISSION, 'ai-apps.resource.mcpToolPermission', getActions(ResourceType.MCP_TOOL_PERMISSION), async () => {
        const catalog = await getToolCatalog();
        return catalog.items.map(it => ({ id: it.name, key: it.name, label: it.name, resourceType: ResourceType.MCP_TOOL_PERMISSION } as ResourceItem));
    }, undefined, [ResourceType.MCP_TOOL_PERMISSION]);
});
